import axios from "axios";

const getAddressByCep = async (cep) => {
  const digits = String(cep || "").replace(/\D/g, "");

  if (digits.length !== 8) {
    throw new Error("CEP não encontrado. Verifique o número digitado.");
  }

  let res;

  try {
    res = await axios.get(`https://viacep.com.br/ws/${digits}/json`);
  } catch (error) {
    throw new Error("CEP não encontrado. Verifique o número digitado.");
  }

  if (res.data.erro) {
    throw new Error("CEP não encontrado. Verifique o número digitado.");
  }

  return res.data;
};

export default getAddressByCep;
